// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hc","advertCardPhoto__image":"c-a_he"};